var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "justify-center mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Formação",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.nomeFormacao,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "nomeFormacao", $$v);
      },
      expression: "form.filters.nomeFormacao"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Solicitante",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.nomeSolicitante,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "nomeSolicitante", $$v);
      },
      expression: "form.filters.nomeSolicitante"
    }
  })], 1), _c('sigfoco-date-picker', {
    attrs: {
      "cols": 2,
      "label": "Data de Solicitação",
      "removeIcon": "",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.dataSolicitacao,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "dataSolicitacao", $$v);
      },
      expression: "form.filters.dataSolicitacao"
    }
  }), _c('sigfoco-date-picker', {
    attrs: {
      "cols": 2,
      "label": "Data de Realização",
      "removeIcon": "",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.dataRealizacao,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "dataRealizacao", $$v);
      },
      expression: "form.filters.dataRealizacao"
    }
  })], 1), _c('v-row', {
    staticClass: "justify-center mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.form.lists.tiposDeStatus,
      "label": "Status",
      "item-text": "situacao",
      "item-value": "id",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.status,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "status", $$v);
      },
      expression: "form.filters.status"
    }
  })], 1), _c('sigfoco-date-picker', {
    attrs: {
      "cols": 2,
      "label": "Buscar por Período - Inicio",
      "removeIcon": "",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.dataPeriodoInicio,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "dataPeriodoInicio", $$v);
      },
      expression: "form.filters.dataPeriodoInicio"
    }
  }), _c('sigfoco-date-picker', {
    attrs: {
      "cols": 2,
      "label": "Buscar por Período - Final",
      "removeIcon": "",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.dataPeriodoFinal,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "dataPeriodoFinal", $$v);
      },
      expression: "form.filters.dataPeriodoFinal"
    }
  })], 1), _c('div', {
    staticClass: "text-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('sigfoco-tooltip', {
    attrs: {
      "text": "Buscar",
      "icon": "mdi-magnify"
    },
    on: {
      "click": function ($event) {
        return _vm.buscarFormacao();
      }
    }
  }), _c('sigfoco-tooltip', {
    attrs: {
      "text": "Limpar",
      "icon": "mdi-eraser"
    },
    on: {
      "click": function ($event) {
        return _vm.resetForm();
      }
    }
  })], 1)], 1)], 1), _c('v-data-table', {
    staticClass: "mt-5",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.form.lists.listFormacoes,
      "items-per-page": 10,
      "footer-props": _vm.$footerProps
    },
    scopedSlots: _vm._u([{
      key: `item.formacao`,
      fn: function (_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(item.formacao) + " ")];
      }
    }, {
      key: `item.solicitante`,
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s(item.solicitante) + " ")];
      }
    }, {
      key: `item.dataSolicitacao`,
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_vm._v(" " + _vm._s(_vm.$formatarData(item.dataSolicitacao)) + " ")];
      }
    }, {
      key: `item.dataRealizacao`,
      fn: function (_ref4) {
        var item = _ref4.item;
        return [_vm._v(" " + _vm._s(_vm.$formatarData(item.dataRealizacao)) + " ")];
      }
    }, {
      key: `item.ativo`,
      fn: function (_ref5) {
        var item = _ref5.item;
        return [_c('sigfoco-label-ativo-inativo', {
          attrs: {
            "ativo": item.ativo
          }
        })];
      }
    }, {
      key: `item.acoes`,
      fn: function (_ref6) {
        var item = _ref6.item;
        return [_c('sigfoco-tooltip', {
          attrs: {
            "text": "Visualizar",
            "icon": "mdi-eye-outline",
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogVisualizarFormacao(item);
            }
          }
        }), item.status == 'Aguardando Consolidação' ? _c('sigfoco-tooltip', {
          attrs: {
            "text": "Consolidar",
            "icon": "mdi-check-circle-outline",
            "disabled": _vm.isOpeningManterFormacao,
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogManterFormacao(item);
            }
          }
        }) : _vm._e(), item.status == 'Aguardando Consolidação' ? _c('sigfoco-tooltip', {
          attrs: {
            "text": "Reprovar",
            "icon": "mdi-close-circle-outline",
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogJustificativaReprovacao(item);
            }
          }
        }) : _vm._e(), item.motivoReagendamento != null && item.statusId == _vm.statusFormacaoEnum.AGUARDANDO_CONSOLIDACAO_REAGENDAMENTO ? _c('sigfoco-tooltip', {
          attrs: {
            "text": "Consolidar reagendamento",
            "icon": "mdi-calendar-edit",
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogAprovarReprovarReagendarFormacao(item);
            }
          }
        }) : _vm._e(), _c('sigfoco-tooltip', {
          attrs: {
            "text": "Baixar Solicitação de Formação",
            "icon": "mdi-arrow-down",
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.baixarRelatorioPdf(item);
            }
          }
        })];
      }
    }], null, true)
  })], 1), _vm.dialogManterFormacao.visible ? _c('CadastrarFormacaoDialog', {
    attrs: {
      "visible": _vm.dialogManterFormacao.visible,
      "content": _vm.dialogManterFormacao.content,
      "edit": _vm.dialogManterFormacao.edit
    },
    on: {
      "onClose": _vm.fecharDialogManterFormacao,
      "onSave": function ($event) {
        return _vm.buscarFormacao();
      }
    }
  }) : _vm._e(), _vm.dialogJustificativaReprovacao.visible ? _c('JustificativaReprovacaoDialog', {
    attrs: {
      "visible": _vm.dialogJustificativaReprovacao.visible,
      "content": _vm.dialogJustificativaReprovacao.content,
      "edit": _vm.dialogJustificativaReprovacao.edit
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogJustificativaReprovacao.close();
      },
      "onReprove": function ($event) {
        return _vm.buscarFormacao();
      }
    }
  }) : _vm._e(), _vm.dialogAprovarReprovarReagendarFormacao.visible ? _c('AprovarReprovarReagendarFormacaoDialog', {
    attrs: {
      "visible": _vm.dialogAprovarReprovarReagendarFormacao.visible,
      "content": _vm.dialogAprovarReprovarReagendarFormacao.content,
      "edit": _vm.dialogAprovarReprovarReagendarFormacao.edit
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogAprovarReprovarReagendarFormacao.close();
      },
      "onAprove": function ($event) {
        return _vm.buscarFormacao();
      }
    }
  }) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }